<template>
<div class="language" 
@click="openDialog"
:dir="t('ltr','rtl')" 
:class="mobileWasUsed?'mobile':''">
  <img :src="whiteWasUsed?languageWhiteImg:languageImg" alt="lang">
  <div :style="{'width':mobileWasUsed?'10px':'5px'}"></div>
  <div class="desc" :class="whiteWasUsed?'white':''">{{ t("English","العربية") }}</div>
  <div :style="{'width':mobileWasUsed?'10px':'5px'}"></div>
  <div class="arrow" :class="whiteWasUsed?'white':''"></div>
  <div v-if="mobileWasUsed" 
  @click.stop="closeDialog"
  class="mobile-dialog" 
  v-show="openedSelector">
    <div class="box">
      <p>{{t("Select your language","تحديد اللغة")}}</p>
      <ul>
        <li @click="$emit('choose-language','en')">
          <div>English</div>
          <div class="circle" :class="language!='ar'?'light':''"></div>
        </li>
        <li @click="$emit('choose-language','ar')">
          <div>العربية</div>
          <div class="circle" :class="language=='ar'?'light':''"></div>
         </li>
      </ul> 
    </div>
  </div>
  <div class="submenu" v-else>
    <div class="holder"></div>
    <p>{{t("Select your language","تحديد اللغة")}}</p>
    <ul>
      <li @click="openedSelector=false,$emit('choose-language','en')">English</li>
      <li @click="openedSelector=false,$emit('choose-language','ar')">العربية</li>
    </ul>
  </div>
</div>
</template>
<script>
import language from "@/assets/img/language.png"
import languageWhite from "@/assets/img/language-white.png"
export default {
  props:{
    whiteWasUsed:Boolean,
    mobileWasUsed:{
      type: Boolean,
      default: false
    },
    language: {
      type: String,
      default: "en"
    }
  },
  data(){
    return {
      languageImg: language,
      languageWhiteImg: languageWhite,
      openedSelector: false
    }
  },
  methods:{
    t(d,ar){
      if(this.language == "ar"){
        if(ar) return ar;
        else return d;
      } else {
        return d;
      }
    },
    closeDialog(e){
      this.openedSelector = false;
    },
    openDialog(e){
      this.openedSelector = true;
    }
  }
}
</script>
<style lang="stylus" scoped>
.language{
  display: flex;
  position: relative;
  align-items: center;

  height: 30px;
  cursor: pointer;
  &:hover{
    .submenu {
      display: block;
    }
  }

  .submenu{
    right: 0px;
    display: none; 
    position: absolute;
    top: 30px;
    width: 410px;
    height: 100px;

    padding: 19px 16px;

    background-color: #ffffff;
    box-shadow: 0px 4px 10px 0px rgba(0, 0, 0, 0.15);
    border-radius: 2px;
    .holder{
      height: 50px;
      margin-top: -50px;
    }
    p{
      color: #818181;
    }
    ul{
      display: flex;
      margin-top: 31px;
      color: #000;
      li{
        width: 75px;
      }
    }

  }
  img{
    width: 15px;
    height: 15px;
  }
  .desc{
    font-size: 14px;
    color: #414141;
    
    &.white{
      color: #fff;
    }
  }
  .arrow {
    width: 0; 
    height: 0; 
    border-left: 6px solid transparent;
    border-right: 6px solid transparent;
    
    border-top: 6px solid #4b4b4b;

    &.white{
      border-top-color: #fff;
    }
  }
  &.mobile{
    height: 56px;
    padding-left: 20px;
    img{
      width: 20px;
      height: 20px;
    }
    .desc{
      font-size: 16px;
      color: #262626;
    }
    .arrow{
      border-left: 8px solid transparent;
      border-right: 8px solid transparent;
      border-top: 8px solid #4b4b4b;
    }
  }
  .mobile-dialog{
    position: fixed;
    top: 0;
    left: 0;
    width: 100%;
    height: 100%;
    background: #000A;
    .box{
      margin: auto;
      width: 343px;
      height: 181px;
      background: #fff;
      position: absolute;
      top: 0;
      bottom: 0;
      left: 0;
      right: 0;
      p{
        height: 68px;
        line-height: 68px;
        padding: 0 24px;
        color: #000;
        font-size: 18px;
        font-family: Helvetica-Bold;
        border-bottom: solid 1px #efeff4;
      }
      ul{
        li{
          height: 54px;
          padding: 0 24px;
          display: flex;
          justify-content:space-between;
          align-items: center;
          border-bottom: solid 1px #efeff4;
          color: #262626;
          font-size: 16px;
          .circle{
            width: 20px;
            height: 20px;
            border: solid #414141 2px;
            border-radius: 50%;
            &.light{
              color:#4378f2;
              border-color: #4378f2;
              font-size: 34px;
              display: flex;
              justify-content: center;
              align-items: center;
              &:before{
                content: "●"
              }
            }
          }
        }
      }
    }
  }
}
</style>